<template>
    <div>
    <!-- add after this -->
        <!-- start breadbrumbs -->
		<div class="mt-4 mb-4">
			<nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/interhom/">Home</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/default.stm">Sustainability</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/building-energy-disclosure.stm">Building Energy Disclosure Project</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Registration</li>                   
                </ol>
			</nav>
		</div>
		<!-- end breadbrumbs -->
		<div class="row">
			<main class="col-12 col-lg-9">
			<div class="cw-content-nosidenav">
				<!-- ***** start custom content ***** -->
				<h1>Registration</h1>

                <p>The following pages will guide you through the Building Energy Disclosure Project registration process. If you have any questions, please <a href="/sustainability/building-energy-disclosure.stm#contact" target="_blank">contact the project administrator</a>.</p>

                <div class="callout callout-warning">
                    <h2>Eligibility</h2>
                    <p>For a building to be eligible to participate, it must meet the following criteria:</p>
                    <ul>
                        <li>Be located within the <a href="https://data.winnipeg.ca/City-Planning/City-Limit/jx93-sett" target="_blank">City of Winnipeg limits</a></li>
                        <li>Have a minimum size of 20,000 sq. ft. (Smaller buildings may be accepted. <a href="/sustainability/building-energy-disclosure.stm#contact" target="_blank">Contact the project administrator</a> to learn more.)</li>
                        <li>Have a minimum of 70% <a href="https://portfoliomanager.zendesk.com/hc/en-us/articles/211026978-How-do-I-determine-my-occupancy-" target="_blank">occupancy</a></li>
                        <li>Be commercial or institutional buildings (as defined in the <a href="/sustainability/documents/bedp/BEDP-project-guide.pdf" target="_blank">project guide</a>)</li>
                        <li>You are willing to share your building’s full energy profile through ENERGY STAR Portfolio Manager®</li>
                    </ul>
                </div>
                
                <p>Do you currently have an ENERGY STAR Portfolio Manager® account for the buildings you’d like to register?</p>
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio1" v-model="hasAccount" value="true" name="customRadio" class="custom-control-input" checked>
                    <label class="custom-control-label" for="customRadio1">Yes</label>
                </div>
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio2" v-model="hasAccount" value="false" name="customRadio" class="custom-control-input">
                    <label class="custom-control-label" for="customRadio2">No</label>
                </div>
                <div class="row mt-5">
                    <div class="col">
                        <button type="button" class="btn btn-outline-secondary" @click="prevpage">Previous page</button>
                    </div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-primary float-right" @click="nextpage">{{buttonLabel}}</button>
                    </div>
                </div>
            </div>
			</main>
		</div>

    <!-- add before this -->
    </div>
</template>

<script>
	export default {
        name: 'signagreement',
        data: function () {
            return {
                hasAccount: false,
                buttonLabel: "Next"
            }
        },
        mounted() {
            this.hasAccount = this.$store.getters.HASACCOUNT;
        },
        methods: {
            prevpage() {
                let nextPage = "Home";

                this.$router.push({ name: nextPage });
            },
            nextpage() {
                //this.$router.push({ name: 'Detail', params: { parameters: this.contactList } });
                let nextPage = "CreateAccount";

                let previousSelection = this.$store.getters.HASACCOUNT;

                if (this.hasAccount === "true" || this.hasAccount === true) {
                    nextPage = "Contact";
                    this.hasAccount = true;
                }

                if (previousSelection !== this.hasAccount) {
                    //let state = this.$store.state;
                    let newState = {};
                    let a = this.$store.getters.PROPERTYLIST;
                    
                    if (a.length > 1) {
                        newState["property"] = null
                        this.$store.replaceState(newState);
                        newState["property_list"] = null
                        this.$store.replaceState(newState);
                    }
                    this.$store.dispatch("SAVE_SUMMARYPAGE", false);
                }

                this.$store.dispatch("SAVE_HASACCOUNT", this.hasAccount);
                
                this.$router.push({ name: nextPage });
            }
        }
	}
</script>